define('views/blocks/checkout/ComeInInformationsView',['jquery', 'underscore', 'backbone', 'app', 'formatPrice',
    'template!blocks/checkout/comein-informations',
  ],
  function ($, _, Backbone, app, formatPrice, ComeInInformationsTemplate) {

    var ComeInInformationsView = Backbone.View.extend({
      className: 'comein-informations',
      overlay: 'translucent',
      events: {
        'click .checkout-opc__cart-popin-close': 'popinComein',
      },
      initialize: function (options) {
        this.render();
      },
      closePopin: function() {
        this.trigger('close', this)
      },
      popinComein: function () {
        var content = $('.checkout-opc__cart-popin-content')
        ,   slideNbr = $('.checkout-opc__cart-popin-item').length
        ,   slideWidth = $('.checkout-opc__cart-popin-item').innerWidth()
        ,   cta = $('.checkout-opc__cart-popin-cta')
        ,   prevButton = $('.checkout-opc__cart-popin-prev')
        ,   position = 0
        ,   view = this

        if (cta.html().length < 1) {
          for (var i = 0; i < slideNbr; i++) {
            var pagination = $('.checkout-opc__cart-popin-pagination')
            i === 0 ? pagination.append('<span class="checkout-opc__cart-popin-pagination-bullet active"></span>') :
              pagination.append('<span class="checkout-opc__cart-popin-pagination-bullet"></span>')
          }
          cta.prepend(t('en savoir plus', 'Product'))
        }

        content.on('scroll', function () {
          var slideActive


          position = $(this).scrollLeft()

          position === slideWidth ? slideActive = 1 : slideActive = Math.floor(position / slideWidth) 
          slideActive > 0 ? prevButton.addClass('active') : prevButton.removeClass('active')

          $('.checkout-opc__cart-popin-pagination-bullet').each(function (index, element) {
            $(element).toggleClass('active', slideActive === index)
          })

          if (position === (slideWidth * slideActive)) {
            if(slideNbr === 4) {
              switch (slideActive) {
                case 0:
                  cta.html('')
                  cta.addClass('popincomein-next')
                  cta.remove('popincomein-done')
                  cta.prepend(t('en savoir plus', 'Checkout'))
                  break
                case 1:
                case 2:
                  cta.html('')
                  cta.addClass('popincomein-next')
                  cta.remove('popincomein-done')
                  cta.prepend(t('suivant', 'Checkout'))
                  break
                case 3:
                  cta.html('')
                  cta.removeClass('popincomein-next')
                  cta.addClass('popincomein-done')
                  cta.prepend(t("j'ai compris", 'Checkout'))
                  break
              }
            } else {
              switch (slideActive) {
                case 0:
                  cta.html('')
                  cta.addClass('popincomein-next')
                  cta.remove('popincomein-done')
                  cta.prepend(t('en savoir plus', 'Checkout'))
                  break
                case 1:
                  cta.html('')
                  cta.addClass('popincomein-next')
                  cta.remove('popincomein-done')
                  cta.prepend(t('suivant', 'Checkout'))
                  break
                case 2:
                  cta.html('')
                  cta.removeClass('popincomein-next')
                  cta.addClass('popincomein-done')
                  cta.prepend(t("j'ai compris", 'Checkout'))
                  break
              }
            }
          }
        })

        prevButton.on('click', function () {
          content.css('scroll-snap-type', 'none')
          content.animate({
            scrollLeft: position - slideWidth
          }, 10, function () {
            content.css('scroll-snap-type', 'x mandatory')
          })
        })

        $('.checkout-opc__cart-popin-close').on('click', function () {
          view.closePopin()
        })

        cta.on('click', function () {
          var state = $(this).attr('class')

          if (state.includes('popincomein-next')) {
            content.css('scroll-snap-type', 'none')
            content.animate({
              scrollLeft: position + slideWidth
            }, 10, function () {
              content.css('scroll-snap-type', 'x mandatory')
            })
          } else if (state.includes('popincomein-done')) {
            view.closePopin()
          }
        })
      },
      render: function () {
        var view = this

        this.$el.html(ComeInInformationsTemplate({formatPrice: formatPrice}));

        setTimeout(function(){
          view.popinComein()
        }, 100)
      },
    });

    return ComeInInformationsView;
  });

